import {PayloadAction} from '@reduxjs/toolkit';
//types
import {INotificationResData, INotificationReducer} from '../../utils/types';

export const pendingOperation = (state: INotificationReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: INotificationReducer) => {
	state.isLoading = false;
};

export const getAllNotificationData = (
	state: INotificationReducer,
	{payload}: PayloadAction<INotificationResData>
) => {
	if (payload.target === 'unread') {
		state.unreadNotificationData.notifications = payload.data;
		state.unreadNotificationData.totalCount = payload.totalCount;
		state.unreadNotificationData.currentPage = payload.currentPage;
		state.unreadNotificationData.totalPages = payload.totalPages;
		state.unreadNotificationData.pageSize = payload.pageSize;
	} else {
		state.allNotificationData.notifications = payload.data;
		state.allNotificationData.totalCount = payload.totalCount;
		state.allNotificationData.currentPage = payload.currentPage;
		state.allNotificationData.totalPages = payload.totalPages;
		state.allNotificationData.pageSize = payload.pageSize;
	}
	state.isLoading = false;
};

export const updateAllNotificationData = (state: INotificationReducer) => {
	state.isLoading = false;
};
